import styled from 'styled-components';

import { Typography } from '@libs/components';

type WarningDisclaimerWrapperProps = {
  shouldShowIcon?: boolean;
};

export const ShouldShowConfirmationWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 1.2rem;
`;
export const CustomTypography = styled(Typography)`
  text-align: center;
`;
export const Img = styled.img`
  width: 8rem;
  height: 8rem;
  margin-top: -4rem;
  margin-bottom: 0.8rem;
`;
export const WarningContainer = styled.div`
  max-width: 50rem;
`;
export const WarningDisclaimerWrapper = styled.div<WarningDisclaimerWrapperProps>`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  /* padding: 0 3.6rem 2.4rem; */
  background-color: ${({ theme }) => theme.colors.surface.interactiveDefault};
  margin-bottom: 2.4rem;
  border-radius: ${({ theme }) => theme.borderRadius.mediumHigh};
  padding: 1.6rem;
  ${({ shouldShowIcon, theme }) => {
    const iconPadding = shouldShowIcon
      ? '0 3.6rem 2.4rem'
      : '2rem 3.6rem 2.4rem';

    return theme.media.tablet`
        padding: ${iconPadding as unknown as TemplateStringsArray};
  `;
  }};
`;

export const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  max-width: 50rem;
  justify-self: center;
  padding: 2.2rem;

  ${({ theme }) => theme.media.tablet`
        padding: 3.6rem;
  `}
`;
